export default __webpack_public_path__ + "static/featureSectionImg-737d6dbf9f30d7211c0b82fd6b476e4a.png";